<template>
  <div class="bg-white pt-4 pl-4">
    <p @click="closeSpotMarkerList" class="btn-close">
      <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><rect height="1" rx=".5" transform="matrix(.70710678 .70710678 -.70710678 .70710678 10.010408 -4.146447)" width="16" x="2.010408" y="9.510408"/><rect height="1" rx=".5" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -4.146447 10.010408)" width="16" x="2.010408" y="9.510408"/></g></svg>
    </p>
    <ul class="place-list flex overflow-x-scroll mt-4">
      <li ref="spotListLeft" class="target-top"></li>
      <template v-if="places.length > 0">
        <li v-for="place in places" v-bind:key="place.id">
          <spot-place :place="place" />
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SpotPlace from './SpotPlace'

export default {
  components: {
    SpotPlace
  },
  computed: {
    ...mapGetters({
      places: 'map/getSpotMarkerList'
    })
  },
  methods: {
    closeSpotMarkerList: function () {
      this.$store.dispatch('map/updateSpotMarkerList', [])
      this.$store.dispatch('drawer/close')
    }
  },
  watch: {
    places: function () {
      this.$refs['spotListLeft'].scrollIntoView()
    }
  }
}
</script>
